import React from "react";
import "./StatusCard.scss";

// Every status string used across the app, mapped onto five visual variants.
// The colours live in StatusCard.scss (theme tokens), not here, so light /
// dark mode and future palette changes need no JS edits.
//   success : good / done        warning : waiting on someone
//   danger  : rejected / late    neutral : cancelled, revoked, unknown
//   info    : informational (e.g. optional holiday)
const VARIANTS = {
  APPROVED: "success",
  PAID: "success",
  EARLY: "success",
  "ON TIME": "success",
  MANDATORY: "success",

  PENDING: "warning",
  REQUESTED: "warning",

  REJECTED: "danger",
  LATE: "danger",

  // Cancelled / revoked are intentionally neutral (not red) so they read
  // differently from Rejected everywhere in the app, matching StatusBadge.
  CANCELED: "neutral",
  CANCELLED: "neutral",
  REVOKE: "neutral",
  REVOKED: "neutral",
  WITHDRAWN: "neutral",

  OPTIONAL: "info",
};

const StatusCard = ({ status }) => {
  // Some callers pre-render a <StatusCard> into their row data and then wrap it
  // again in a column renderer. Pass an element straight through rather than
  // trying to read it as a string.
  if (React.isValidElement(status)) return status;

  const key = String(status ?? "")
    .trim()
    .toUpperCase();
  const variant = VARIANTS[key] || "neutral";

  return (
    <span className={`status-card status-card--${variant}`}>
      {status || "N/A"}
    </span>
  );
};

export default StatusCard;
